import type { ValueEvent } from '@adornis/base/utilTypes.js';
import { TrMailsTemplateEditor } from '@adornis/bh-mail-editor/client/tr-mails-template-editor.js';
import { getMenteeUserClass, getMentorUserClass } from '@adornis/bh-matching-user/user-class.js';
import { InstitutionMailTemplate, MailTemplateType } from '@adornis/buchungsheld-db/entities/mail-templates.js';
import { globalMailHint } from '@adornis/buchungsheld-db/mails/mail-template-catalog.js';
import { isDefined } from '@adornis/buchungsheld-db/util.js';
import '@adornis/buchungsheld-theme/fonts/fonts.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { xComponents } from '@adornis/chemistry/elements/x-components.js';
import { mailTemplateDefinitions } from '@adornis/mails/db/mail-template-definition.js';
import type { MailTemplate } from '@adornis/mails/db/mail-template.js';
import { clientTranslator } from '@adornis/translation-core/client/clientTranslator.js';
import { html, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import './matching-mail-editor.js';

/**
 * @element matching-mails-template-editor
 */
@customElement('matching-mails-template-editor')
export class TrBuddyMailsTemplateEditor extends TrMailsTemplateEditor {
  protected override _templateSelection() {
    console.log('this mailtemp', this.mailTemplates);
    const mailTemplates = Object.values(this.mailTemplates)
      .map(templates => templates.at(0))
      .filter(isDefined)
      .map(template => {
        template.scope = 'default';
        return template;
      });

    if (mailTemplates.length > 1)
      return xComponents(html`
        <tr-dropdown-selection
          placeholder="Template auswählen"
          .value=${null}
          .selectables=${mailTemplates}
          .renderString=${(template: MailTemplate) =>
            template.name
              .replace('Mentor', clientTranslator.translate('user', getMentorUserClass()._class))
              .replace('Mentee', clientTranslator.translate('user', getMenteeUserClass()._class))}
          @value-picked=${(e: ValueEvent<MailTemplate>) => {
            this.selectedMailType = e.detail.value.emailType;
            this.selectedMailScope = 'default';
            this.requestUpdate();
          }}
          .guardFunction=${(item: MailTemplate) => {
            const template = item as InstitutionMailTemplate;
            return [template.whatsappNotification, template.emailNotification].join();
          }}
        ></tr-dropdown-selection>
        <x-hr></x-hr>
      `);
    return nothing;
  }

  protected override editSection(selectedTemplate: MailTemplate) {
    const templateDefinition = mailTemplateDefinitions[selectedTemplate.emailType];
    console.log('template', selectedTemplate, templateDefinition);
    return html`
      <tr-flex space="md">
        <tr-flex horizontal space="md" flex>
          <tr-flex
            ${css({ background: '#fff', borderRadius: '5px', padding: this.spacing.lg, marginBottom: this.spacing.md })}
            space="md"
            flex
          >
            <tr-text bold> Beschreibung: </tr-text>
            <tr-text>
              ${
                templateDefinition?.editorHint() ??
                globalMailHint(selectedTemplate.emailType as any as MailTemplateType)
              }
            </tr-text>
          </tr-flex>

          ${(() => {
            // TODO: are notification settings needed in matching?
            return nothing;
            // return this._notificationTypeSelection()
          })()}
        </tr-flex>
        <matching-mail-editor
          .value=${selectedTemplate}
          ?clearable=${this.clearable}
          ?overriding=${this.overriding}
          attachments
        ></matching-mail-editor>
      </tr-flex>
    `;
  }
}
